export default __webpack_public_path__ + "static/media/instagram (1).3ede1abe.svg";